
import React from "react";
import { Card, CardContent, Typography, Grid, Box } from "@mui/material";
import { FaRobot, FaBrain, FaEye, FaChartLine, FaComments, FaLightbulb, FaMicrochip, FaCogs, FaHeadset, FaUser, FaDatabase, FaSync, FaHdd, FaShieldAlt, FaChartPie, FaCloud, FaAws } from "react-icons/fa";
import OurNumbers from "./OurNumbers";

const DataEngineering = () => {
  return (
    <Box sx={{ padding: "40px", maxWidth: "1200px", margin: "auto" }}>

        <Card
          sx={{
            background: "rgba(0, 0, 0, 0.9)",
            color: "white",
            borderRadius: "12px",
            padding: "30px",
            boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
            backdropFilter: "blur(15px)",
            textAlign: "center",
          }}
        >
          <CardContent>
            <Typography variant="h4" fontWeight="bold" gutterBottom>
            Empowering Your Business with Data Engineering
            </Typography>
            <Typography variant="body1" sx={{ opacity: 0.9 }}>
            Harness the power of data engineering to streamline your data processes, ensure data quality, and drive informed decision-making.
            </Typography>
          </CardContent>
        </Card>

        {/* Data Engineering Services Section */}
      <Grid container spacing={3} sx={{ marginTop: "40px" }}>
        {aiServices.map((service, index) => (
          <Grid item xs={12} sm={6} md={4} key={index}>
            <Card sx={glassyCardStyle}>
              <Box sx={logoBox}>{service.icon}</Box>
              <Typography variant="h6" fontWeight="bold">
                {service.title}
              </Typography>
              <Typography variant="body2" sx={{ marginTop: "10px", color: "#222" }}>
                {service.description}
              </Typography>
            </Card>
          </Grid>
        ))}
      </Grid>

      {/* Statistics Section - Animated UX Grid */}
      
      <OurNumbers/>
    </Box>
  );
};

// Glassy Card Style
const glassyCardStyle = {
  border: "1px solid rgba(255, 255, 255, 0.2)",
  borderRadius: "10px",
  boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
  backgroundColor: "rgba(255, 255, 255, 0.15)",
  padding: "20px",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  textAlign: "center",
  backdropFilter: "blur(10px)",
  minHeight: "220px",
};

// Stylish Number Presentation
const statsBoxStyle = {
  borderRadius: "10px",
  padding: "20px",
  backgroundColor: "rgba(255, 255, 255, 0.2)",
  boxShadow: "0 2px 8px rgba(0, 0, 0, 0.2)",
  backdropFilter: "blur(12px)",
  textAlign: "center",
  minWidth: "200px",
};

const logoBox = {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: "80px",
    height: "80px",
    borderRadius: "10px",
    backgroundColor: "rgb(211, 154, 158, 0.08)",
    marginBottom: "15px",
    boxShadow: "0 0 5px rgb(211, 154, 158), 0 0 10px rgb(211, 154, 158), 0 0 20px rgb(211, 154, 158)",
    fontSize: "2rem", // Adjust the font size to make the icon larger
};

// Expanded AI Services with Hot AI Topics
const aiServices = [
    {
        title: "Data Warehousing",
        description: "Implement scalable data warehousing solutions to centralize and manage your data.",
        icon: <FaDatabase />,
    },
    {
        title: "ETL Processes",
        description: "Design and optimize ETL processes to ensure efficient data integration and transformation.",
        icon: <FaSync />,
    },
    {
        title: "Big Data Solutions",
        description: "Leverage big data technologies to handle and analyze large volumes of data.",
        icon: <FaHdd />,
    },
    {
        title: "Data Governance",
        description: "Establish data governance frameworks to ensure data quality and compliance.",
        icon: <FaShieldAlt />,
    },
    {
        title: "Data Visualization",
        description: "Create interactive and insightful data visualizations to support decision-making.",
        icon: <FaChartPie />,
    },
    {
        title: "GCP Solutions",
        description: "Utilize Google Cloud Platform services for scalable and reliable data engineering solutions.",
        icon: <FaCloud />,
    },
    {
        title: "AWS Solutions",
        description: "Implement Amazon Web Services for robust and flexible data engineering infrastructure.",
        icon: <FaAws />,
    },
];


export default DataEngineering;